<script type="text/javascript">
function isPC() {
  let browser = navigator.userAgent.toLowerCase();
  let Agents = ["symbianos", "windows phone",
  "iphone", "ipod", "ipad", "android", "mobile", "blackberry", "webos", "incognito", "webmate", "bada", "nokia", "lg", "ucweb", "skyfire"];
  let flag = true;
  for (let i = 0; i < Agents.length; i++) {
    if (browser.indexOf(Agents[i]) != -1) {
      flag = false;
      break;
    }
  }
  return flag;
}
export default {
  isPC
};
</script>



// WEBPACK FOOTER //
// src/components/Global.vue